// src/domain/utilities/UtilityFootprint.ts

/**
 * UtilityFootprint - Represents the physical footprint of a utility node.
 * Length/Width are stored in meters (model units).
 */
export class UtilityFootprint {
  /** Footprint length in meters */
  LengthMeters: number;

  /** Footprint width in meters */
  WidthMeters: number;

  constructor(data: {
    LengthMeters: number;
    WidthMeters: number;
  }) {
    this.LengthMeters = data.LengthMeters;
    this.WidthMeters = data.WidthMeters;
  }

  /**
   * Creates a UtilityFootprint from a plain object (e.g. ECSQL row).
   */
  static fromObject(obj: Partial<UtilityFootprint>): UtilityFootprint {
    return new UtilityFootprint({
      LengthMeters: obj.LengthMeters ?? 0,
      WidthMeters: obj.WidthMeters ?? 0,
    });
  }

  /**
   * Convenience empty instance.
   */
  static empty(): UtilityFootprint {
    return new UtilityFootprint({
      LengthMeters: 0,
      WidthMeters: 0,
    });
  }

  /**
   * Converts the UtilityFootprint to a plain object.
   */
  toObject(): Record<string, unknown> {
    return {
      LengthMeters: this.LengthMeters,
      WidthMeters: this.WidthMeters,
    };
  }

  /**
   * Derived convenience getters in feet (optional).
   * Not stored, just computed from meters.
   */
  get LengthFeet(): number {
    return this.LengthMeters * 3.280839895013123;
  }

  get WidthFeet(): number {
    return this.WidthMeters * 3.280839895013123;
  }
}
